import { createContext, useContext, useState } from "react";

// Create Context
const CheckoutContext = createContext();

// Checkout Provider Component
export const CheckoutProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState([]);
  const [subtotal, setSubtotal] = useState(0);
  const [shipping, setShipping] = useState(0);
  const [total, setTotal] = useState(0);

  // Function to proceed to checkout
  const proceedToCheckout = (cart) => {
    if (!cart || cart.length === 0) {
      console.warn("Cart is empty or undefined");
      return;
    }

    // Format cart items - preserve all fields including type and selectedMachines
    const items = cart.map((item) => ({
      productId: item._id || item.productId,
      name: item.name,
      quantity: item.quantity,
      price: item.price,
      images: item.images || [],
      type: item.type || 'product', // Default to 'product' if not specified
      selectedMachines: item.selectedMachines, // Preserve selected machines for embroidery designs
      designCode: item.designCode // Preserve design code if it's an embroidery design
    }));

    // Calculate totals - No delivery charges
    const cartSubtotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const shippingCost = 0; // Free delivery - no extra charges
    const orderTotal = cartSubtotal; // Total = product price only

    // Update state
    setCartItems(items);
    setSubtotal(cartSubtotal);
    setShipping(shippingCost);
    setTotal(orderTotal);
  };

  return (
    <CheckoutContext.Provider value={{ cartItems, setCartItems, subtotal, shipping, total, proceedToCheckout }}>
      {children}
    </CheckoutContext.Provider>
  );
};

// Custom hook to use CheckoutContext
export const useCheckout = () => {
  const context = useContext(CheckoutContext);
  if (!context) {
    throw new Error("useCheckout must be used within a CheckoutProvider");
  }
  return context;
};
